module.exports = __webpack_public_path__ + "static/media/toggler.c84f0c7d.svg";